// Pure decisions shared by the ordering entry and its regression checks.
export function storefrontState(profile) {
  if (profile?.brand_key === "rolls_and_brew" && profile?.operating_status === "live") {
    return { kind: "ready" };
  }
  if (profile?.brand_key && profile?.display_name) {
    return { kind: "unconfigured", name: profile.display_name };
  }
  return { kind: "error" };
}

export function orderStartupState(parts) {
  const expired = parts.brand === "preview-expired" || parts.storefront === "preview-expired" || parts.storefront === "preview-unbound";
  const blocked = expired || parts.brand === "error" || parts.brand === "mismatch"
    || parts.storefront === "error" || parts.storefront === "unconfigured"
    || parts.route === "error" || parts.menu === "error";
  const ready = parts.brand === "ready" && parts.storefront === "ready" && parts.menu === "ready";
  const status = expired ? "Open a fresh Test/Demo page from the staff app." : blocked ? "We couldn't open ordering. Please try again."
    : parts.brand !== "ready" ? "Verifying your restaurant…"
    : parts.storefront !== "ready" ? "Checking restaurant availability…"
    : parts.menu !== "ready" ? "Preparing your menu…" : "Ready to serve.";
  return { ready, blocked, status };
}

// Count visible playback only. The animation never expires while its art is
// decoding, while this tab is hidden, or before the ordering checks finish.
export function createOrderSplashClock({ onExit, onDone, now = () => performance.now(),
  setTimer = (fn, ms) => window.setTimeout(fn, ms), clearTimer = (id) => window.clearTimeout(id) }) {
  let elapsed = 0, started = null, playing = false, ready = false;
  let exitAt = null, finishAt = null, exiting = false, stopped = false, completed = false;
  let timers = [];
  const cancel = () => { timers.forEach(clearTimer); timers = []; };
  const settle = () => {
    if (started !== null) elapsed += Math.max(0, now() - started);
    started = playing ? now() : null;
  };
  const schedule = () => {
    cancel();
    if (stopped || completed || !playing || !ready) return;
    if (exitAt === null) {
      exitAt = Math.max(3660, elapsed);
      finishAt = Math.max(4000, exitAt + 340);
    }
    if (!exiting) timers.push(setTimer(() => {
      settle();
      exiting = true;
      onExit(true);
    }, Math.max(0, exitAt - elapsed)));
    timers.push(setTimer(() => {
      settle();
      completed = true;
      cancel();
      onDone();
    }, Math.max(0, finishAt - elapsed)));
  };
  return {
    update(next) {
      if (stopped || completed) return;
      settle();
      playing = !!next.playing;
      ready = !!next.ready;
      started = playing ? now() : null;
      if (!ready) {
        exitAt = finishAt = null;
        if (exiting) { exiting = false; onExit(false); }
      }
      schedule();
    },
    stop() { stopped = true; cancel(); },
  };
}
